export default [
    { 'Kokoro v1.0': 'Basic' },
    { 'IndexTTS2': 'Pro' },
    { 'indextts2': 'Pro' }
];
